// Generated by ReScript, PLEASE EDIT WITH CARE


let windowOrigin = (function() {
    return typeof window !== "undefined" && window.location
      ? window.location.origin
      : "http://localhost:8080";
  });

let resolveApiBase = (function(explicit) {
    var origin = (typeof window !== "undefined" && window.location)
      ? window.location.origin
      : "http://localhost:8080";
    var hostname = "";
    try { hostname = new URL(origin).hostname; } catch (e) {}
    var hosted = hostname !== "localhost" && hostname !== "127.0.0.1";
    if (hosted) {
      return origin;
    }
    return explicit || "http://localhost:4000";
  });

function apiBase() {
  return resolveApiBase(process.env.API_BASE);
}

function graphqlEndpoint() {
  let url = process.env.GRAPHQL_ENDPOINT;
  if (url === "") {
    return resolveApiBase(process.env.API_BASE) + "/graphql";
  } else {
    return url;
  }
}

function oauthConfig() {
  let base = resolveApiBase(process.env.API_BASE);
  return {
    clientId: process.env.OAUTH_CLIENT_ID,
    redirectUri: windowOrigin() + "/callback",
    authorizeUrl: base + "/oauth/authorize",
    tokenUrl: base + "/oauth/token",
    userInfoUrl: base + "/oauth/userinfo",
    scopes: [
      "openid",
      "profile",
      "email"
    ]
  };
}

export {
  windowOrigin,
  resolveApiBase,
  apiBase,
  graphqlEndpoint,
  oauthConfig,
}
/* No side effect */
